import {
  CreatableModel,
  CreateModelBase,
  ModelBase,
  ModifiableModel,
} from 'shared/domain/baseModelTypes';
import { Identificable } from 'shared/types/commonView';

interface MapBase {
  documentationId: string;
  versionId: string;
}
export type MapModel = Identificable &
  CreatableModel &
  ModifiableModel &
  MapBase;

export interface WithSiteLabel { siteLabel?: string }

export type LevelModel = ModelBase & {
  label: string;
  index: number;
  site: string;
  maps: MapModel[];
} & WithSiteLabel;

export type LevelEditModel = Identificable & {
  map?: MapBase;
  label?: string;
  projectId: string;
};

export type LevelCreateModel = CreateModelBase & {
  label: string;
  site: string;
  index: 0;
  projectId: string;
  map?: MapBase;
};

/**
 * Returns the primary (first) map assigned to a level.
 * Levels support multiple maps but UI typically operates on the first one.
 */
export function getPrimaryMap(level: LevelModel): MapModel | undefined {
  return level.maps[0];
}
